module.exports = __webpack_public_path__ + "static/media/hit.7214df07.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/hit.ogg
// module id = 118
// module chunks = 0